import React, { useRef, useCallback, useState } from "react";
import { PlayButton } from "components";
import * as S from "./styles";

export const Slide8: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const handlePlayVideo = useCallback(() => {
    if (videoRef.current) {
      if (videoRef.current.played.length > 0 && !videoRef.current.paused) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  }, []);

  return (
    <S.Container>
      <S.Video>
        <PlayButton action={handlePlayVideo} playing={isPlaying} />
        <video loop ref={videoRef}>
          <source
            src="https://player.vimeo.com/external/604139947.hd.mp4?s=f80ea38d4cd0481253ba5ee7ac113547739cd7c2&profile_id=175"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
